import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../sections/CheckinEntry";
import MaintenanceWorkflowForwardingCheckoutEntrySection from "../../../sections/CheckoutEntry";
import MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry from "../../../sections/DirectiveEntry/entries/ExecutionEntry";

const ExecutionEntryOnGoingCheckout = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckoutEntrySection />

      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingDirectiveEntryExecutionEntry
        showCompleted
      />
    </>
  );
}

export default ExecutionEntryOnGoingCheckout;
